import CartLegend from './CartLegend'

export default CartLegend
